// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7ec72b28","239":"36b366bf","455":"b3cf5cb7","762":"c426518f"}[chunkId] + ".chunk.js";
};